import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M11 21.995A11 11 0 1 1 21.994 11 11.01 11.01 0 0 1 11 21.995m0-20.4a9.405 9.405 0 1 0 9.4 9.404A9.413 9.413 0 0 0 11 1.594\"></path><path d=\"M11 8.529a1.276 1.276 0 1 0 0-2.552 1.276 1.276 0 0 0 0 2.552M11.985 9.509h-1.978v6.51h1.978z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h22v22H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }